module.exports = __webpack_public_path__ + "static/img/waz.3b0ffd58.jpg";